module.exports = __webpack_public_path__ + "img/english-flag-icon.69d359b2.svg";